import { z } from 'zod'
import { useZodForm, validateEmissionDate } from '@minetrace/ui/forms'

export const powerValiditySchema = z.object({
  code: z.string().min(1, 'Código es requerido'),
  issueDate: z.string().min(1, 'Fecha de emisión es requerida'),
}).superRefine((data, ctx) => {
  validateEmissionDate(data.issueDate, 'issueDate', ctx)
})

export type PowerValidityFormValues = z.infer<typeof powerValiditySchema>

const defaultValues: PowerValidityFormValues = {
  code: '',
  issueDate: '',
}

export const useStep1PowerValidityForm = (props?: { defaultValues?: PowerValidityFormValues; disabled?: boolean }) => {
  return useZodForm<PowerValidityFormValues>({
    validationSchema: powerValiditySchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
